export const formatCurrency = (countryCode, value = 0) => {
  let formattedValue = Number(value);

  const getFormattedValue = (countryCode, currency, value) => {
    return new Intl.NumberFormat(countryCode, {
      // style: "currency",
      // currency: currency,
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(value);
  };

  const getFormattedFractionValue = (countryCode, currency, value) => {
    return new Intl.NumberFormat(countryCode, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(value);
  };

  let func = getFormattedValue;

  if (countryCode === "IN" || countryCode === "SG") {
    if (value % 1 !== 0) {
      func = getFormattedFractionValue;
    }
  }

  // India
  if (countryCode === "IN") {
    formattedValue = `₹ ${func("en-IN", "INR", value)}`;
  }
  // Vietnam
  else if (countryCode === "VI" || countryCode === "VN") {
    formattedValue = `${func("vi-VN", "VND", value)} đ`;
    formattedValue = formattedValue.replace(/[.]/g, ",");
  }
  // South Korea
  else if (countryCode === "KR") {
    formattedValue = `${func("ko-KR", "KRW", value)} 원`;
  }
  // Singapore
  else if (countryCode === "SG") {
    formattedValue = `S$ ${func("en-SG", "SGD", value)}`;
  }

  return formattedValue;
};

export const currencyPosition = {
  IN: "left",
  SG: "left",
  VI: "right",
  VN: "right",
  KR: "right",
};
